import React from 'react';
import product from '../../product';
import { motion } from 'framer-motion';

const Skill = () => {
  return (
    <div
      className={`w-screen h-screen flex items-center justify-center`}
      id="/skill"
    >
      <div className="text-center w-[80%] mx-auto items-center justify-center ">
        <h1 className="text-4xl font-extrabold">My Skills</h1>
        <motion.div
          className="grid lg:grid-cols-5 grid-cols-3 mt-10 items-center gap-7 w-100% justify-center bg-[#d7d7d7] lg:p-8 p-6 rounded-md"
          initial={{ y: 100, opacity: 0 }}
          whileInView={{ y: 0, opacity: 1 }}
          transition={{
            delay: 0.1,
            y: { type: 'spring', stiffness: 100 },
            opacity: { duration: 0.8 },
            ease: 'easeIn',
            duration: 1,
          }}
        >
          {product.map((item, i) => (
            <div key={i} className=" flex flex-col text-center items-center ">
              <img src={item.logo} alt="" className=" size-20 max-h-10 w-14 " />
              <p className="font-bold text-black">{item.title}</p>
            </div>
          ))}
        </motion.div>
      </div>
    </div>
  );
};

export default Skill;
